import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Bg from '../../images/bg/page_bg01.jpg'
import CtaSection from '../../components/CtaSection/CtaSection';
import icon from '../../images/icon/magic.svg'
import gImg1 from '../../images/gallery/c1.png'
import gImg2 from '../../images/gallery/c2.png'
import gImg3 from '../../images/gallery/c3.png'
import gImg4 from '../../images/gallery/c4.png'
import gImg5 from '../../images/gallery/c5.png'
import gImg6 from '../../images/gallery/c6.png'

const PrivacyPage = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <Fragment>
            <div className='body_wrap sco_agency'>
                <Header />
                <section className="page-title cp-page-title pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="page-title-wrap">
                            <div className="row mt-none-30 align-items-center">
                                <div className="col-lg-8 mt-30">
                                    <div className="page-title-box">
                                        <span className="sub-title"><img src={icon} alt="" />Privacy Policy</span>

                                        {/* UPDATED TITLE */}
                                        <h2 className="title">
                                            Uniflame website privacy <br />
                                            policy — how we protect <br />
                                            your data and access rights
                                        </h2>

                                      
                                    </div>
                                </div>

                                <div className="col-lg-4 mt-30">
                                    <div className="cp-img-slide">
                                        <div className="cp-img-inner ul_li">
                                            <div className="cp-item marquee-first">
                                                <div className="xb-img"><img src={gImg1} alt="" /></div>
                                                <div className="xb-img"><img src={gImg2} alt="" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="" /></div>
                                                <div className="xb-img"><img src={gImg1} alt="" /></div>
                                                <div className="xb-img"><img src={gImg2} alt="" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="" /></div>
                                            </div>
                                            <div className="cp-item marquee-2">
                                                <div className="xb-img"><img src={gImg4} alt="" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="" /></div>
                                                <div className="xb-img"><img src={gImg4} alt="" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="" /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section className="terms&conditions-section cp-det-bg">
                    <div className="container">
                        <div className="terms-section_inner pt-120 pb-75">
                            <div className="row">
                                <div className="col-lg-11">

                                    {/* UPDATED ALL CONTENT BELOW */}

                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Data controller and data collection</h2>
                                        <p>
                                            Uniflame is committed to protecting your privacy while delivering ERP, eCommerce, mobile app,
                                            and cloud solutions. We collect Personal Data based on your interaction with our website or
                                            service enquiries. This may include contact information, project details, browser data,
                                            cookies, and usage analytics to improve user experience.
                                        </p>
                                        <p>
                                            Some information is required to provide demos, support, quotations, and service onboarding—
                                            especially for Odoo, Shopify, Magento, and custom integration requests.
                                        </p>
                                    </div>

                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">User responsibilities</h2>
                                        <p>
                                            Users are responsible for ensuring that any business data, customer records, or documents
                                            shared with Uniflame for ERP or integration purposes are lawfully obtained. By submitting such
                                            data, users confirm they have the right to use and share it.
                                        </p>
                                    </div>

                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Data processing and security</h2>
                                        <p>
                                            All data collected is processed securely within Uniflame’s internal systems or trusted cloud
                                            infrastructure. We use strong encryption, restricted access policies, and secure communication
                                            channels to ensure your business data, ERP credentials, and integration details remain protected.
                                        </p>
                                        <p>
                                            Only authorized Uniflame personnel (project managers, technical leads, system engineers) may
                                            access required data strictly for service delivery.
                                        </p>
                                    </div>

                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Data storage and retention</h2>
                                        <p>
                                            Personal and project-related data is retained only as long as required to deliver Odoo
                                            implementations, API integrations, or ongoing support. Users may request deletion of stored
                                            data at any time unless legally restricted.
                                        </p>
                                    </div>

                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Legal action</h2>
                                        <p>
                                            Uniflame may disclose data only when legally required or during investigations involving
                                            misuse of ERP credentials, unauthorized server access, or platform violations.
                                        </p>
                                    </div>

                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">User rights</h2>
                                        <p>
                                            Users have full rights to access, update, restrict, or delete their stored personal or
                                            business data. Uniflame supports transparency and will assist with any request related to:
                                        </p>
                                        <ul className="privacy-details">
                                            <li>Accessing your stored data</li>
                                            <li>Correcting errors or outdated information</li>
                                            <li>Requesting deletion of project data</li>
                                            <li>Receiving data in a transferable format</li>
                                            <li>Restricting or objecting to specific processing</li>
                                            <li>Withdrawing consent at any time</li>
                                            <li>Lodging a complaint if rights are violated</li>
                                        </ul>
                                    </div>

                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">"Do not track" requests</h2>
                                        <p>
                                            Uniflame systems do not currently support “Do Not Track” browser requests. Third-party tools
                                            such as analytics or ad services may have their own policies, which users should review
                                            separately.
                                        </p>
                                    </div>

                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Policy updates</h2>
                                        <p>
                                            Uniflame may periodically update this Privacy Policy to reflect improvements in security,
                                            compliance, or changes to our ERP and eCommerce service offerings. Continued website usage
                                            implies acceptance of revisions.
                                        </p>
                                    </div>

                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Retargeting and ad cookies</h2>
                                        <p>
                                            Uniflame uses cookies to optimize user experience and may use limited advertising cookies to
                                            display relevant service information (Odoo, Magento, Shopify, App Development). No sensitive
                                            data is collected. Users may opt out via the Network Advertising Initiative.
                                        </p>
                                    </div>

                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">Contact</h2>
                                        <p>
                                            <Link onClick={ClickHandler} to="/contact" className="details-link">Click here</Link> to contact us regarding this
                                            Privacy Policy or any data-related concerns.  
                                            You can also email us at: <br />
                                            <a href="mailto:support@uniflame.org">support@uniflame.org</a>
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <CtaSection cClassNamclassName={'bg'} />

            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default PrivacyPage;
